import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  filterBox: false,
  propertiesReset: false,
  auctionDraft: null,
};

export const propertieSlice = createSlice({
  name: "propertie",
  initialState,
  reducers: {
    // setAnswerValue: (state, actions: PayloadAction<ISetAnswerValue>) => {
    //   state.answerSubmitValue = actions.payload.data
    // },
    setFilterBox: (state) => {
      state.filterBox = !state.filterBox;
    },
    setInvitesListReset: (state) => {
      state.propertiesReset = !state.propertiesReset;
    },
    setAuctionDraft: (state, action: PayloadAction<any>) => {
      state.auctionDraft = action.payload;  
    },
  },
});

export const propertieAction = propertieSlice.actions;
export const propertieReducer = propertieSlice.reducer;
